import { skipToken } from '@reduxjs/toolkit/query'
import { PatientIdentityStatus } from '@/core/models/patient.model'
import { useGetPatientQuery } from '@/core/services/patient'
import { useIdentityStatus } from '@/entities/patient'
import { FeatureFlag, useIsFlagEnabled } from '@/hooks/useIsFlagEnabled'
import { selectDMPConnectTlsiConnectorId } from '@/redux/reducers/dmp-connect.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { useIsINSEnabled } from '@/shared/model/useIsINSEnabled'

export function useShowDMP(patientId?: string) {
  const isDmpConnectEnabled = useIsFlagEnabled(FeatureFlag.DmpConnect)
  const { data: patient } = useGetPatientQuery(patientId ?? skipToken)
  const { isINSEnabled } = useIsINSEnabled(patient)
  const tlsiConnectorId = useAppSelector(selectDMPConnectTlsiConnectorId)
  const { identityStatus } = useIdentityStatus(patientId)

  return isDmpConnectEnabled && isINSEnabled && !!tlsiConnectorId && identityStatus === PatientIdentityStatus.QUALIFIED
}
